<template>
  <button
    v-if="updateAvailable"
    type="button"
    class="btn btn-primary indicator max-md:btn-square"
    :class="$props.class"
    :title="$t('dialog.update-available.title')"
    @click="show"
  >
    <FontAwesomeIcon :icon="faCloudArrowDown" />
    <span class="hidden md:inline">{{ $t('dialog.update-available.label') }}</span>
    <span class="indicator-item status status-lg status-warning animate-ping" />
    <span class="indicator-item status status-lg status-warning" />
  </button>
</template>

<script setup lang="ts">
import { faCloudArrowDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { useVersionHistoryDialog } from '../../composables/dialog/useVersionHistoryDialog';
import { usePwaUpdate } from '../../composables/usePwaUpdate';
import type { ClassValue } from 'vue';

defineProps<{
  class?: ClassValue;
}>();

const { updateAvailable } = usePwaUpdate();
const { show } = useVersionHistoryDialog();
</script>
